export default __webpack_public_path__ + "static/media/game_ram.b7293790.svg";